module.exports = __webpack_public_path__ + "img/lips.05531220.svg";